import type { SectionItem } from './types';

type NavGroup = {
  title: string;
  items: SectionItem[];
  exclusiveLabel?: string;
  exclusiveItems?: SectionItem[];
};

type Groups = {
  foundationSections: SectionItem[];
  componentSections: SectionItem[];
  webExclusiveSections?: SectionItem[];
};

export function buildNavGroups({
  foundationSections,
  componentSections,
  webExclusiveSections,
}: Groups): NavGroup[] {
  return [
    { title: 'Foundations', items: foundationSections },
    {
      title: 'Components',
      items: componentSections,
      ...(webExclusiveSections && {
        exclusiveLabel: 'Web Exclusive',
        exclusiveItems: webExclusiveSections,
      }),
    },
  ];
}
